import {RESET_COMPANY_CREATE,SET_USER_COMPANY_CREATE,GET_COMPANY_GROUP_COMPANY_CREATE,GET_ALL_COMPANY_BY_USER_COMPANY_CREATE,GET_ALL_BRANCH_BY_USER_COMPANY_CREATE,GET_ALL_MODULES,GET_ALL_USER_BY_USER_COMPANY_CREATE,GET_Branches_LIST_Register,GET_SPECIFIC_USER_BRANCH_COMPANY_CREATE} from '../../../constants/ActionTypes'
import {getRequest,postRequest,putRequest} from '../Axios'

export const SetUserId=(id)=>({
     type:SET_USER_COMPANY_CREATE,
     payload:id
})

export const GetCompanyGroupByUser=(UserId)=>(dispatch)=>{
    dispatch(getRequest("CompanyGroup/GetCompanyGroupByUserId",{UserId}))
    .then(({payload:{data}})=>{
        dispatch({
            type:GET_COMPANY_GROUP_COMPANY_CREATE,
            payload:data
        })
    })
}

export const AddCompanyGroup=(params,dataParams,CallBack)=>(dispatch)=>{
        dispatch(postRequest("/CompanyGroup/AddOrUpdateComponentGroup",params,dataParams))
        .then(({payload:{data,status}})=>{
            CallBack(data,status);
        })
}

export const GenerateAPIECFToken= (params)=>async(dispatch)=>{
    return await dispatch(getRequest("/CompanyGroup/GenerateAPIECFToken",params))
    .then(({ payload: { data, status } }) => ({ data, status }))
    .catch(() => null);
}


export const SendCompanyToAPIECF= (params) => async(dispatch)=>{
    return await dispatch(postRequest("/CompanyGroup/SendCompanyToAPIECF",{},params))
    .then(({ payload: { data, status } }) => ({ data, status }))
    .catch(() => null);
}

export const GetCompany=(UserId)=>(dispatch)=>{
    dispatch(getRequest("Companies/GetCompanyByUser",{UserId}))
    .then(({payload:{data}})=>{
        dispatch({
            type:GET_ALL_COMPANY_BY_USER_COMPANY_CREATE,
            payload:data
        })
    })
}

export const AddCompany=(params,CallBack)=>(dispatch)=>{
    dispatch(postRequest("/Companies/AddOrUpdateCompany",{},params))
    .then(({payload:{data,status}})=>{
        CallBack(data,status);
    })
}
export const GetBranch=(UserId)=>(dispatch)=>{
    dispatch(getRequest("Branches/GetBranchByUser",{UserId}))
    .then(({payload:{data}})=>{
        dispatch({
            type:GET_ALL_BRANCH_BY_USER_COMPANY_CREATE,
            payload:data
        })
    })
}

export const GetModule=(UserId)=>(dispatch)=>{
    dispatch(getRequest("ModuleHelp/GetModules",{UserId}))
    .then(({payload:{data}})=>{
        dispatch({
            type:GET_ALL_MODULES,
            payload:data
        })
    })
}

export const GetRestrictionWithCompany =(companyId)=>async(dispatch)=>{
    return await dispatch(getRequest(`/Companies/GetRestrictionWithCompany`,{CompanyId:companyId}))
    .then(({payload:{data,status}})=>({data,status}))
    .catch(error=>null)
}

export const AddRestrictionToCompany=(params,CallBack)=>(dispatch)=>{
    dispatch(postRequest("/Companies/AddRestrictionToCompany",{},params))
    .then(({payload:{data,status}})=>{
        CallBack(data,status);
    })
}

export const UpdateRestrictionModule=(params,callBackFunction)=>(dispatch)=>{
   dispatch(putRequest(`/Companies/UpdateRestrictionModule`,params,params))
   .then(resp=>{
        const {payload:{data,status}}=resp;
        callBackFunction(data,status);
   }).catch(error=>console.error(error));

}


export const GetAllBranches =()=>async(dispatch)=>{
    return await dispatch(getRequest(`/Branches/GetAllCompanyBranch`))
    .then(({payload:{data,status}})=>({data,status}))
    .catch(error=>null)
}

export const GetBranchesByCode = (Code, CallBack) => async (dispatch) => {
    return await dispatch(getRequest(`/Branches/GetBranchByCode`,{ Code }))
        .then(({ payload: { data, status } }) => ({data,status}))
        .catch((error) => console.error(error))
}



export const AddBranch=(params,CallBack)=>(dispatch)=>{
    dispatch(postRequest("/Branches/AddUpdateBranch",{},params))
    .then(({payload:{data,status}})=>{
        CallBack(data,status);
    })
}

export const GetUsers=(UserId)=>(dispatch)=>{
    dispatch(getRequest("Users/GetUsersByUserAdmin",{UserId}))
    .then(({payload:{data}})=>{
        dispatch({
            type:GET_ALL_USER_BY_USER_COMPANY_CREATE,
            payload:data
        })
    })
}

export const AddUser=(params,DatParams,CallBack)=>(dispatch)=>{
    dispatch(postRequest("/Users/AddUserWithUserAdmin",params,DatParams))
    .then(({payload:{data,status}})=>{
        CallBack(data,status);
    })
}


export const PutPassWord=(password,callBackFunction)=>(dispatch)=>{
   dispatch(putRequest(`/Users/UpdatePassWord`,{...password},{...password}))
   .then(resp=>{
        const {payload:{data,status}}=resp;
        callBackFunction(data,status);
   }).catch(error=>console.error(error));

}

export const GetUserBranch=(UserId,CallBack)=>(dispatch)=>{
    dispatch(getRequest("Users/GetUserBranches",{UserId}))
    .then(({payload:{data}})=>{
         CallBack(data);
    })
}

export const SetUserBranch=(params,DatParams,CallBack)=>(dispatch)=>{
    dispatch(postRequest("/Users/SetUserCompanyBranch",params,DatParams))
    .then(({payload:{data,status}})=>{
        CallBack(data,status);
    })
}

export const ResetCompanyCreate=()=>({
    type:RESET_COMPANY_CREATE
})